import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import Bilder from "./Bilder";

import { getMiljokontrollBilder as getMiljokontrollBilderAction } from "../../../../actions/miljokontrollerActions";

export default function BilderContainer({ id, ...rest }) {
  const dispatch = useDispatch();
  const dateSortedThumbnailImageArray = useSelector(
    (state) => state.miljokontrollerThumbnailBilder[id],
  );
  const dateSortedLightboxImageArray = useSelector(
    (state) => state.miljokontrollerLightboxBilder[id],
  );

  const getMiljokontrollBilder = useCallback(
    (miljokontrollId, params) =>
      dispatch(getMiljokontrollBilderAction(miljokontrollId, params)),
    [dispatch],
  );

  return (
    <Bilder
      {...rest}
      id={id}
      dateSortedThumbnailImageArray={dateSortedThumbnailImageArray}
      dateSortedLightboxImageArray={dateSortedLightboxImageArray}
      getMiljokontrollBilder={getMiljokontrollBilder}
    />
  );
}
